export default __webpack_public_path__ + "static/media/browser-listing.21e9c205.jpg";